import styled from "styled-components";
import JourneyData from "../../components/JourneyData";
import PageBackButton from "../../components/PageBackButton";
import SelectFlight from "../Home/SelectFlight";
import ConfirmRequestRightContainer from "./ConfirmRequestRightContainer";
import { useNavigate } from "react-router-dom";
import { useBookingContext } from "../../contexts/BookingContext";
import { useEffect, useRef } from "react";
import { useGuestContext } from "../../contexts/GuestContext";
import { usePaxContext } from "../../contexts/PassengerContext";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";

const ConfirmRequest = () => {
  const confirmReqRef = useRef(null);
  const { booking, setBooking } = useBookingContext();
  const { guests, setGuests } = useGuestContext();
  const { passengers, setPax } = usePaxContext();
  const { extraFields, setExtraFields } = useExtraFieldsContext();

  const navigate = useNavigate();

  const handlePrivilegeClubChange = (e, index) => {
    let pax = [...passengers];
    pax[index]["privilegeClub"] = e.target.value;
    setPax([...pax]);
  };

  useEffect(() => {
    confirmReqRef.current.scrollIntoView();
  }, []);

  return (
    <ConfirmRequestContainer ref={confirmReqRef}>
      {/* {JSON.stringify(booking)} */}
      <Heading>
        <PageBackButton
          label="Confirm Request"
          handleClick={() => navigate("/user/dashboard")}
        />
      </Heading>
      <ConfirmRequestWholeContainer>
        <JourneyDataWrapper>
          <JourneyData
            passengers={passengers}
            guests={guests}
            formData={booking}
            children={[]}

            // passengers={passengers}
            // children={[]}
            // guests={passengers}
          />
        </JourneyDataWrapper>
        <ConfirmRequestRightContainer
          passengers={passengers}
          guests={guests}
          formData={booking}
          extraFields={extraFields}
          onPrivilegeClubChange={handlePrivilegeClubChange}
        />
      </ConfirmRequestWholeContainer>
    </ConfirmRequestContainer>
  );
};

const ConfirmRequestContainer = styled.div`
  padding: 1.5rem 2.5rem 0rem;
  @media only screen and (max-width: 768px) {
    padding: 1.5rem 2.5rem;
  }
  @media only screen and (max-width: 580px) {
    padding: 1.5rem 1rem;
  }
`;

const ConfirmRequestWholeContainer = styled.div`
  display: flex;
  gap: 3rem;
  padding: 1.25rem 0rem 0rem;

  // @media only screen and (min-width: 481px) and (max-width: 768px) {
  //   flex-direction: column;
  //   gap: 2rem;
  // }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1.25rem;
  }
`;

const JourneyDataWrapper = styled.div`
  width: 45%;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  @media only screen and (min-width: 769px) and (max-width: 1000px) {
    width: 45%;
  }
`;

const Heading = styled.div`
  // padding-bottom: 1.3rem;

  // @media only screen and (max-width: 768px) {
  //   padding-bottom: 0rem;
  // }
`;

export default ConfirmRequest;
